
class modalSureRed {
    constructor($scope, $uibModalInstance, items1) {
        $scope.modaldata = {
            invoiceIds: [],
        }
        $scope = $.extend($scope, items1)
        $scope.params = items1

        // 关闭
        $scope.cancel = function cancel() {
            $uibModalInstance.dismiss('cancel')
        }
        // 确定
        $scope.ok = function ok() {
          
            $uibModalInstance.close(items1)
        }

        // 导出
        $scope.import = function () {
            let getdata = []
            for (let i = 0; i < items1.length - 1; i++) {
                getdata.push(items1[i].invoiceIds)
            }
            getdata = getdata.join(',')
            let dataStr = '?'

            dataStr = `${dataStr}accessToken=${localStorage.id_token}&invoiceIds=${getdata}`
            let url = `${host.etcloudOvat}openedInvoice/exportReddingInvoices`
            url += dataStr
            window.open(url)
        }
    }
}

modalSureRed.$inject = ['$scope', '$uibModalInstance', 'items1']
export default modalSureRed



// WEBPACK FOOTER //
// ./src/app/outputManage/billManage/openedInvoice/modalSureRed.js